import React from "react";
import { AppList } from "components/list/AppList";
import { CloneButton, Datagrid, TextField } from "react-admin";

import CustomerField from "../../../components/fields/CustomerField";
import { DateTimeField } from "../../../components/fields/DateFormatField";
import { LinkFieldToOther } from "../../../components/fields/LinkField";
import { SelectEnumField } from "../../../components/fields/SelectEnumField";
import { NotifObjectType } from "../../../entities/NotifObjectType";
import { NotifStatus } from "../../../entities/NotifStatus";
import { NotifType } from "../../../entities/NotifType";
import { ResendButton } from "../Buttons/ResendButton";
import Filters from "../Filter/Filters";
import { ObjectField } from "./Fields";

const getStatusColorClass = (status) => {
	switch (status) {
		case 1:
			return "#FFFFFF";
		case 2:
			return "#00AFF3";
		case 3:
			return "#b7ff7d";
		case 4:
			return "#ff8c8c";
		case 5:
			return "#D1AC19";
	}
};

const rowStyle = (record) => ({
	backgroundColor: getStatusColorClass(record.status),
});

const defaultSort = {
	field: "time",
	order: "DESC",
};

const VisibleWrapper = ({ component: Component, ...props }) => {
	if (![NotifType.email, NotifType.sms].includes(props.record["type"])) {
		return null;
	}
	return <Component {...props} />;
};

const NotifLogs = ({ permissions, ...props }) => (
	<AppList
		{...props}
		exporter={false}
		bulkActionButtons={false}
		sort={defaultSort}
		filters={<Filters />}
	>
		<Datagrid rowStyle={rowStyle}>
			<TextField source="id" />
			{/* <TextField source="order_id" /> */}
			<SelectEnumField source="type" enumName="notif.type" enumObj={NotifType} sortable={false} />
			<SelectEnumField
				source="object_type"
				enumName="notif.object_type"
				enumObj={NotifObjectType}
				sortable={false}
			/>
			<ObjectField source="object_id" />

			{/* <TextField source="sender" /> */}

			{/* <DateTimeField source="time" withLocalTimeZone /> */}
			<TextField source="recipient" sortable={false} />
			<TextField source="recipient_name" />
			<CustomerField
				source="recipient_company"
				formatLabel={(record) => record["recipient_company_name"]}
				sortable={false}
			/>

			<TextField source="title" style={{ whiteSpace: "normal" }} sortable={false} />
			<TextField source="text" style={{ whiteSpace: "normal" }} sortable={false} />
			<SelectEnumField source="status" enumName="status" enumObj={NotifStatus} sortable={false} />
			<DateTimeField label="created" source="time" withLocalTimeZone />
			<DateTimeField label="sent" source="time_sent" withLocalTimeZone />

			<LinkFieldToOther
				source="customer_name"
				otherResource="customer-companies"
				otherIdProp="customer_id"
			/>
			<LinkFieldToOther
				source="eta_3rd_party_name"
				otherResource="customer-companies"
				otherIdProp="eta_3rd_party"
			/>
			<LinkFieldToOther
				source="etd_3rd_party_name"
				otherResource="customer-companies"
				otherIdProp="etd_3rd_party"
			/>

			<VisibleWrapper component={CloneButton} />
			<VisibleWrapper component={ResendButton} />
		</Datagrid>
	</AppList>
);

export default NotifLogs;
